import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana98Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1462_13741)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M294.715 517.232L349.826 490.565L378.271 549.232L333.826 570.566C323.871 574.832 316.641 566.418 314.27 561.677L294.715 517.232Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M433.378 520.791L378.266 549.235L349.822 490.569L406.711 462.124L433.378 520.791Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M490.269 494.12L433.38 520.787L406.713 462.12L463.602 435.453L490.269 494.12Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M520.484 408.786L463.595 435.453L490.262 494.12L547.151 467.453L520.484 408.786Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M577.381 382.12L520.492 408.787L547.159 467.454L591.604 446.12C600.137 441.854 598.715 428.935 596.937 423.009L577.381 382.12Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M550.71 325.231L577.377 382.12L529.377 403.453L497.376 337.675L525.821 323.453C540.043 314.92 548.34 321.083 550.71 325.231Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M451.156 360.785L497.379 337.674L529.379 403.452L481.379 426.563L451.156 360.785Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M403.153 383.902L451.153 360.791L481.375 426.569L433.375 449.68L403.153 383.902Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M355.157 407.01L403.157 383.898L433.38 449.676L385.38 472.788L355.157 407.01Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M308.931 428.344L355.154 407.011L385.376 472.789L339.153 495.9L308.931 428.344Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M275.163 444.342L308.941 428.342L339.165 495.898L294.72 517.231L269.823 467.453C264.134 456.075 270.422 446.712 275.163 444.342Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13741" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13741" transform="matrix(0.00243853 0 0 0.00323283 -4.76148 -2.77464)"/>
    </pattern>
    <image id="image0_1462_13741" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};